/**
 * @desc 获取商户微信实名认证结果
 */

import * as defs from '../../baseClass'
import axios from '@/services/request'

export class Params {
  /** merchantNo */
  merchantNo?: string
  /** paymentCode */
  paymentCode?: string
}

export const init = new defs.SimpleResponse()

export async function request(params) {
  return axios({
    url: '/api/scp-cashier-business/merchant/weChatVerifiedResult',
    params,
    method: 'get',
  })
}
